import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import Select, { components } from "react-select";
import useFetchList from "../../utils/useFetchLIst";
import MaterialIntakeCreate from "./MaterialApprovalForm";
import { loaderOverlay } from "../../Style/loaderOverly";
import { LoaderCreatePage } from "../Loader/Loader";
import { saveRecords } from "../../services/api.service";
// import useFetchList from "../../../utils/useFetchList";

const CustomOption = (props) => {
  const { label, subLabel } = props.data;
  const { isSelected } = props;

  const isActive = isSelected;

  return (
    <components.Option {...props}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <span
          style={{
            color: isActive ? "#fff" : "#000",
          }}
        >
          {label} ({subLabel})
        </span>

        <span
          style={{
            color: isActive ? "#fff" : "#777",
          }}
        ></span>
      </div>
    </components.Option>
  );
};

const CustomSingleValue = (props) => {
  const { label, subLabel } = props.data;

  return (
    <components.SingleValue {...props}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <span>
          {label} ({subLabel})
        </span>
        <span style={{ color: "#777" }}></span>
      </div>
    </components.SingleValue>
  );
};

const filterOption = (option, inputValue) => {
  const search = inputValue.toLowerCase();

  return (
    option.label.toLowerCase().includes(search) ||
    option.data.subLabel.toLowerCase().includes(search)
  );
};

const MaterialApproval = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    material: "",
  });
  const [selectedMaterial, setSelectedMaterial] = useState(null); // Add this line
  const [selectedMaterialData, setSelectedMaterialData] = useState(null);
  const [errors, setErrors] = useState({});
  const [materialOptions, setMaterialOptions] = useState([]);
  const [showMaterialApproval, setShowMaterialApproval] = useState(false);
  const navigate = useNavigate();
  const schema = localStorage.getItem("schema");

  useEffect(() => {
    const storedData =
      JSON.parse(localStorage.getItem("selectedUserData")) || [];
    const foundCustomer = storedData.find(
      (customer) => customer.id === parseInt(id),
    );

    if (foundCustomer) {
      setFormData(foundCustomer);
    }
  }, [id]);

  const payload = {
    modelName: "material_intakes",
    schema: schema,
    whereCondition: {
      is_active: true,
      status: "Pending",
    },
    orderBy: {
      field: "intake_no",
      order: "asc",
    },
    include: [
      { model: "material_masters", as: "material" },
      { model: "user_masters", as: "received_by_user" },
      { model: "client_masters", as: "customer" },
    ],
  };

  const { data: materialData, loading } = useFetchList("/getRecords", payload);

  useEffect(() => {
    if (materialData) {
      const options = materialData.map((material) => ({
        value: material?.id,
        label: `${material?.intake_no}`,
        subLabel: material?.material
          ? material?.material?.gmds_code || material?.material?.name
          : "-",
      }));
      setMaterialOptions(options);
    }
  }, [materialData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
    if (name === "material" && value) {
      materialData.map((material) => {
        if (material.id === value) {
          setSelectedMaterial({
            value: material?.id,
            label: `${material?.intake_no} (${
              material?.material?.gmds_code || material?.material?.name
            })`,
            subLabel: material?.material
              ? material?.material?.gmds_code || material?.material?.name
              : "-",
          });
          setSelectedMaterialData(material);
          setShowMaterialApproval(false);
        }
      });
    } else setShowMaterialApproval(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    let newErrors = {};
    let valid = true;

    if (!String(formData.material).trim()) {
      newErrors.material = "Material cannnot be blank.";
      valid = false;
    }

    if (!valid) {
      setErrors(newErrors);
      return;
    }
    try {
      const payload = {
        modelName: "job_cards",
        schema: schema,
        whereCondition: { intake_id: selectedMaterial.value },
        include: [
          {
            model: "user_masters",
            as: "technician",
          },
        ],
      };
      const responseData = await saveRecords(payload, "/getRecords");
      console.log(responseData);
    } catch (error) {}
    setShowMaterialApproval(true);
  };

  return (
    <>
      <div className="page-content">
        <Breadcrumbs title={"Material Approval"} breadcrumbItems={[]} />
        <div className="card mb-3">
          <div className="container-fluid p-4 ">
            <p className="text-muted pb-1">
              Fields marked with <span className="text-danger fw-bold">*</span>{" "}
              are required.
            </p>
            <form onSubmit={handleFormSubmit}>
              <div className="row mb-3 align-items-center">
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label className="form-label custom-label">
                      Material <span className="text-danger">*</span>
                    </label>
                    <Select
                      className={`font-size-13 ${
                        errors.material ? "is-invalid" : ""
                      }`}
                      options={materialOptions}
                      value={selectedMaterial}
                      components={{
                        Option: CustomOption,
                        SingleValue: CustomSingleValue,
                      }}
                      filterOption={filterOption}
                      onChange={(selectedOption) => {
                        handleChange({
                          target: {
                            name: "material",
                            value: selectedOption ? selectedOption.value : "",
                          },
                        });
                        setSelectedMaterial(
                          selectedOption ? selectedOption : "",
                        );
                      }}
                      placeholder="Select Material"
                      isSearchable
                      isClearable
                      onMenuOpen={() => {}}
                      menuPortalTarget={document.body}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          borderColor: errors.material
                            ? "#dee2e6"
                            : base.borderColor,
                          boxShadow: errors.material
                            ? "0 0 0 0.5px red"
                            : base.boxShadow,
                          "&:hover": {
                            borderColor: errors.material
                              ? "#dee2e6"
                              : base.borderColor,
                          },
                        }),
                      }}
                    />
                    {errors.material && (
                      <div className="invalid-feedback">{errors.material}</div>
                    )}
                  </div>
                </div>
                <div className="col-6 mt-3 mb-2">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{
                      width: "80px",
                      fontSize: "13px",
                    }}
                  >
                    {id ? "Update" : "Go"}
                  </button>
                </div>
              </div>
            </form>
          </div>
          {loading && (
            <div style={loaderOverlay}>
              <LoaderCreatePage />
            </div>
          )}
        </div>
        {showMaterialApproval && (
          <MaterialIntakeCreate
            intakeNo={selectedMaterial?.label}
            materialsData={selectedMaterialData}
            materialId={selectedMaterial?.value}
          />
        )}
      </div>
    </>
  );
};

export default MaterialApproval;
